import React from 'react';
import { useSearchParams } from "react-router-dom";

import './tags_menu.scss';
import CheckableTag from "antd/es/tag/CheckableTag";

interface TagInterface {
  label: string;
  color?: string | null;
  key: string;
}

export interface TagsMenuInterface {
  className?: string;
  paramsKey?: string;
  items: TagInterface[];
}

const TagsMenu = ({ className, items, paramsKey = 'tag_id' }: TagsMenuInterface) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedTags = searchParams.get(paramsKey)?.split(',') || [];

  let extraClassName = 'v-tags-menu';
  extraClassName = className ? `${extraClassName} ${className}` : extraClassName;

  function onChangeTab(tag: TagInterface, checked: boolean) {
    const newKeys = checked ? [...selectedTags, tag.key] : selectedTags.filter(t => t !== tag.key);

    if (newKeys.length) {
      searchParams.set(paramsKey, newKeys.join(','));
    } else {
      searchParams.delete(paramsKey)
    }
    setSearchParams(searchParams)
  }

  const isChecked = (key: string) => {
    return selectedTags.includes(key);
  }

  const tagStyle = (tag: TagInterface) => {
    const style: any = { borderColor: '#1890ff' };

    if (!tag.color) {
      return style;
    }

    if (isChecked(tag.key)) {
      style.borderColor     = tag.color;
      style.backgroundColor = tag.color;
    } else {
      style.color       = tag.color;
      style.borderColor = tag.color;
    }

    return style;
  }

  const renderTags = (tag: TagInterface) => {
    return (
      <CheckableTag
        style={tagStyle(tag)}
        key={tag.key}
        checked={isChecked(tag.key)}
        onChange={checked => onChangeTab(tag, checked)}
      >
        {tag.label}
      </CheckableTag>
    )
  }

  return (
    <div className={extraClassName}>
      {items.map(renderTags)}
    </div>
  );
}

export default TagsMenu;
